import { TableCell } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

export const SpecificationInfoCell = styled(TableCell)`
  padding: 2px 0 0 !important;
  align-items: center;

  ${({ theme }) => theme.breakpoint.maxWidth('md')} {
    display: none;
  }
`;

export const ShortSpecificationTableCell = styled(TableCell)`
  width: 60%;
  cursor: pointer;
`;

export const SpecificationTableCell = styled(TableCell)`
  width: 50%;
  cursor: pointer;

  ${({ theme }) => theme.breakpoint.minWidth('lg')} {
    width: 40%;
  }
`;
